import mixpanel from "mixpanel-browser"

export const storeDomain = 'shop.liftrider.me'
export function getStoreUrl(){return `https://${storeDomain}/collections/liftrider/products/liftrider-2-0`}
export function getStoreUrlSurveyDiscount(){return `https://${storeDomain}/discount/SurveyReward`}

export function getStoreUrlParams(){return `?mp_uid=${mixpanel.get_distinct_id()}`}
export function getStoreUrlWithParams(){return getStoreUrl() + getStoreUrlParams()}
export function getStoreUrlSurveyDiscountWithParams(){return getStoreUrlSurveyDiscount() + getStoreUrlParams()}